import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { TranslateService } from "@ngx-translate/core";
import { merge } from "rxjs";
import { tap } from "rxjs/operators";
import { TasDataSource } from "src/app/services/tasGovTable.datasource";
import { TaxPayerService } from "src/app/services/taxPayer.service";

@Component({
  selector: "app-check-deposits",
  templateUrl: "./check-deposits.component.html",
  styleUrls: ["./check-deposits.component.css"],
})
export class CheckDepositsComponent implements OnInit, OnChanges {
  @Input()
  currentYear: any;
  @Input()
  category: any;
  @Input()
  currentNIU: any;
  currentYearInt: any;
  displayedYears = [];
  dataSource: TasDataSource;
  displayedColumns: string[] = ['checkDate', 'status', 'amount', 'number', 'source'];
  @Input() company: any;
  filterObject: any;
  loading = { inProgress : true}
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  
  constructor(
    public translate: TranslateService,
    public taxPayerService: TaxPayerService,
    public dialog: MatDialog,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.category) {
        this.displayedColumns = ['checkDate', 'status', 'amount', 'number', 'source'];
    }
  }

  ngOnInit() { 
    this.dataSource = new TasDataSource(this.taxPayerService);
      this.taxPayerService.getTaxPayerByNiu('tax-payers', this.currentNIU).subscribe(taxPayer => {
        this.company = taxPayer
        this.dataSource = new TasDataSource(this.taxPayerService);
      })

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loading.inProgress = true
      this.filterObject = { tin: this.currentNIU}
      this.dataSource.loadData(
        'payments/checks',
      this.stringifyWithUTC(this.filterObject),
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, this.filterObject, this.loading
      );
    }, 1000)

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
 

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
       tap(() => this.loadTable())
    )
      .subscribe();

  }
  stringifyWithUTC(obj) {
    return JSON.stringify(obj, (key, value) => {
      if (obj && obj[key] instanceof Date) {
        const utcDateString = new Date(obj[key].getTime() - (obj[key].getTimezoneOffset() * 60000)).toISOString();
        return utcDateString
      }
      return value;
    });
  }
  
  loadTable() {
    this.loading.inProgress = true
    this.dataSource.loadData(
      'payments/checks',
      this.stringifyWithUTC(this.filterObject),
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, this.filterObject, this.loading
    );
  }
  advancedSearch(filter){
    for(let key in filter){
      this.filterObject[key] = filter[key]
    }
    this.loadTable()
  }
}
